/**
 * 报警计划基本信息组件
 * 创建时间：2017-05-11
 * 创建人：zhanlz
 * 修改时间：2017-04-18
 */
<template>
    <div>
		<div class="row">
			<div class="col-sm-6  gray_right">
				<div class="module_title"> <span>报警种类与基本信息</span> </div>
				<div class="row">
					<div class="col-sm-5">
						<div class="alarm_list_icon" :class="[bgClass]"> <em><img :src="imageData" width="30" height="30" alt=""/></em> <span>{{title}}</span> </div>
					</div>
					<div class="col-sm-7">
						<form class="form-horizontal">
							<div class="form-group">
								<label class="col-sm-4 control-label focus_color">报警计划名称</label>
								<div class="col-sm-8">
									<input class="form-control" v-model.trim="alarmBaseInfo.alarmPlanName">
								</div>
							</div>
							<div class="form-group mb10px">
								<label class="col-sm-4 control-label focus_color">报警计划状态</label>
								<div class="col-sm-8 form-control-static pb0px">
									<label class=" pr20px">
										<radio v-model="alarmBaseInfo.alarmPlanStatus" true-value="1">启用</radio>
	            					</label>
									<label class="">
										<radio v-model="alarmBaseInfo.alarmPlanStatus" true-value="0">停用</radio>
	            					</label>
								</div>
							</div>
						</form>
						<div class="annotation_text"> {{systemAlarms}}</div>
					</div>
				</div>
			</div>
			<div class="col-sm-6  gray_left">
				<div class="module_title"> <span class="focus_color">请指定报警等级</span> </div>
				<div class="row">
					<div class="col-sm-4 t_center">
						<div class="alarm_level_icon alarm_list_bg06" @click="baseInfoAlarmLevel(1)" :class="{active : alarmUrgentActive}"> <em><img src="../../../../assets/project/images/alarm_level_01.png"  alt=""/></em> <span>紧急报警</span> </div>
						<radio v-model="alarmBaseInfo.alarmLevel" true-value="1" uiposition="center"></radio>
					</div>
					<div class="col-sm-4 t_center">
						<div class="alarm_level_icon alarm_list_bg05" @click="baseInfoAlarmLevel(2)" :class="{active : alarmNormalActive}"> <em><img src="../../../../assets/project/images/alarm_level_02.png"  alt=""/></em> <span>一般报警</span> </div>
						<radio v-model="alarmBaseInfo.alarmLevel" true-value="2" uiposition="center"></radio>
					</div>
					<div class="col-sm-4 t_center">
						<div class="alarm_level_icon alarm_list_bg09" @click="baseInfoAlarmLevel(3)" :class="{active : alarmCommonActive}"> <em><img src="../../../../assets/project/images/alarm_level_03.png"  alt=""/></em> <span>普通提醒</span> </div>
						<radio v-model="alarmBaseInfo.alarmLevel" true-value="3" uiposition="center"></radio>
					</div>
				</div>
			</div>
		</div>
		<div class="hr-line-dashed"></div>
		<div class="row">
			<div class="col-sm-12 ">
				<div class="module_title"> <span>备注</span> </div>
				<textarea class="form-control" rows="4" v-model="alarmBaseInfo.alarmPlanNote"></textarea>
			</div>
		</div>
	</div>	
</template>

<script>
import Radio from 'components/common/Radio' 
import { OPERATE_EXCEPTION} from 'static/message'
export default {
    name: 'AlarmPlanBase',
    components: {
    	Radio
    },
    props: {
        imageData: {
			type: String,
			dafault: ""
		},
		title: {
			type: String,
			dafault: ""
		},
		bgClass: {
			type: String,
			dafault: ""
		},
		systemAlarms: {
			type: String,
			dafault: ""
		}
    },
    data() {
        return {
        	alarmBaseInfo:{
        		alarmPlanName: '',            //报警计划名称
				alarmPlanNote: '',            //报警计划备注
				alarmPlanStatus: '1',         //报警计划状态
				alarmLevel: '1'          //报警等级
        	},
        };
    },
    beforeMount(){
    	this.initEditInfo();
    },
    created(){
    	this.$emit('input', this.alarmBaseInfo)
    },
    computed: {
    	//紧急报警激活状态(第一步)
	    alarmUrgentActive: function () {
	    	return this.alarmBaseInfo.alarmLevel=='1';
	    },
	    //一般报警激活状态(第一步)
	    alarmNormalActive: function () {
	    	return this.alarmBaseInfo.alarmLevel=='2';
	    },
	    //一般报警激活状态(第一步)
	    alarmCommonActive: function () {
	    	return this.alarmBaseInfo.alarmLevel=='3';
	    },
    },
    methods: {
    	baseInfoAlarmLevel(level){
    		this.alarmBaseInfo.alarmLevel = level;
    	},
    	//编辑时初始化信息
    	initEditInfo(){
    		if (this.$parent.mode=='1' || this.$parent.mode=='2'){
    			this.$parent.loadingstatus.base = true;
    			let param = {
    				planId:this.$parent.planid
    			}
    			if (this.$parent.mode=='1') param.type="1";
    			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.$parent.planid + '/info', {params: param})
					.then((response) => {
						if(response.body.success) {
							let alarmModeInfo = response.body.data;
							this.alarmBaseInfo.alarmPlanName = alarmModeInfo.planName;
							this.alarmBaseInfo.alarmPlanNote = alarmModeInfo.memo;
							this.alarmBaseInfo.alarmPlanStatus = alarmModeInfo.isenable;
							this.alarmBaseInfo.alarmLevel = alarmModeInfo.almLevel;
						} else {
							this.$parent.openModalMsg(response.data.message);
						}
						this.$parent.loadingstatus.base = false;
					}, (response) => {
						this.$parent.openModalMsg(response.data.message);
						this.$parent.loadingstatus.base = false;
					})
					.catch((response) => {
						this.$parent.openModalMsg(OPERATE_EXCEPTION);
						this.$parent.loadingstatus.base = false;
					}	
				)
    		}
    	}
    },
    watch: {
    	alarmBaseInfo:{
    		handler(newValue, oldValue) {
　　　　　　		this.$emit('input', this.alarmBaseInfo)
　　　　		},
			deep:true
    	}
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AlarmPlanBase.vue?2d8de9ba